import { ToastOptions, toast } from 'react-toastify'
import useAppRouter from './useAppRouter'

export const SNACKBAR_CONTAINER_ID = 'new-design-system-snackbar-container'

const useSnackbar = () => {
  const router = useAppRouter()
  const isWebviewUrl = (pathname: string) => {
    return pathname.includes('webview')
  }

  const commonSnackbarOptions: ToastOptions = {
    theme: 'light',
    containerId: SNACKBAR_CONTAINER_ID,
    className: `p-[6px] rounded-[8px] ${isWebviewUrl(router.asPath) && 'mx-16 mt-16'}`,
  }

  const snackbar = (content: string | React.ReactNode, customConfig?: ToastOptions) => {
    if (typeof window === 'undefined') {
      return // Return early if there's no window object
    }

    toast(content, {
      ...commonSnackbarOptions,
      ...customConfig,
    })
  }

  return snackbar
}

export default useSnackbar
